<script lang="ts">
  import RadioGroup from "../../components/RadioGroup.svelte";
  import CloseButton from "../../components/CloseButton.svelte";
  import { type Component } from "svelte";

  let {
    answer,
    inactive,
    financeCompany,
    creditCheckable,
    nextSteps,
  }: {
    answer: ({ nextStep }) => void;
    inactive: boolean;
    financeCompany: string;
    creditCheckable: boolean;
    nextSteps: { [key: string]: Component };
  } = $props();

  let selectedOption = $state(null);
  let options = $derived([
    [["Upload my finance agreement", "(<1 minute)"], "upload"],
    creditCheckable && [["Soft credit check to find my agreements", "(<1 minute)"], "credit_check"],
    [["Answer a few questions instead", "(2-3 minutes)"], "questions"]
  ].filter(Boolean)) as [any, string][]

  function handleContinue() {
    if (selectedOption === "upload") {
      answer({ nextStep: nextSteps.next });
    } else if (selectedOption === "credit_check") {
      answer({ nextStep: nextSteps.credit });
    } else if (selectedOption === "questions") {
      answer({ nextStep: nextSteps.questions });
    }
  }
</script>

<div class="h-full">
  <h2 class="ui-title">Reply to finance company</h2>

  <p>
    <b>{financeCompany}</b> has informed us that they could not find records confirming
    that you were their client.
  </p>

  <p class="mb-4">To proceed with your claim, we need to confirm your finance agreement details.</p>

  <fieldset class="ui-fieldset">
    <legend>Choose one of the options below to continue.</legend>
    <RadioGroup
      name="finance_agreement[option]"
      {options}
      bind:group={selectedOption}
    >
      {#snippet option([title, subtitle])}
        <div class="flex flex-col">
          {title}
          <span class="text-sm text-gray-500">{subtitle}</span>
        </div>
      {/snippet}
    </RadioGroup>
  </fieldset>
</div>

<div class="floating-footer">
  <CloseButton />
  <button
    type="submit"
    class="btn btn-primary"
    onclick={handleContinue}
    disabled={!selectedOption || inactive}>Continue</button
  >
</div>
